<script setup lang="ts">
import { RouterView } from 'vue-router';
import Header from '@/components/wireframe/TopHeader.vue';
import SideNav from '@/components/wireframe/SideNav.vue';
import ToastNotification from '@/components/ToastNotification.vue';
</script>

<template class="scroll-smooth">
    <div class="flex dark:bg-gray-600">
        <!-- sidebar  -->
        <SideNav class="sideBar" />
        <!-- content  -->
        <div class="mainContent w-4.5/6">
            <!-- site header  -->
            <Header class="mainHeader" />
            <!-- main content -->
            <RouterView class="bg-slate-100 dark:bg-gray-700 dark:text-gray-400 h-100" />
        </div>
        <ToastNotification />
    </div>
</template>

<style lang="scss">
@import '@/index.scss';
/* scrollbar */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track-piece {
    background-color: #fff;
}

::-webkit-scrollbar-thumb {
    background-color: #cbcbcb;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 0.1px solid #b7b7b7;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #909090;
}
/* end scrollbar */
</style>
